import { preloadSettlements } from "~/utils/preload/settlements";

export default defineNuxtRouteMiddleware(async () => {
  await preloadSettlements();
});
